import { atom, useAtom } from "jotai";

export const isDowngradedPerformanceDismissedAtom = atom(false);

export const useIsDowngradedPerformanceDismissed = () => {
  const [
    isDowngradedPerformanceDismissed,
    setIsDowngradedPerformanceDismissed,
  ] = useAtom(isDowngradedPerformanceDismissedAtom);

  return {
    isDowngradedPerformanceDismissed,
    setIsDowngradedPerformanceDismissed,
  };
};
